export default __webpack_public_path__ + "static/media/36-min.457a4d42.png";